// 存储适配器
export * from './adapter';
// 数据访问层
export * from './dal';
// 存储工具和常量
export { STORAGE_KEYS } from '@/shared/constants';
// 存储相关的工具函数
export const StorageUtils = {
    // 计算存储使用量（仅在支持的环境中）
    async getStorageUsage() {
        if ('storage' in navigator && 'estimate' in navigator.storage) {
            try {
                const estimate = await navigator.storage.estimate();
                return {
                    used: estimate.usage || 0,
                    total: estimate.quota || 0,
                };
            }
            catch (error) {
                console.warn('Failed to get storage usage:', error);
            }
        }
        return null;
    },
    // 格式化存储大小
    formatStorageSize(bytes) {
        const units = ['B', 'KB', 'MB', 'GB'];
        let size = bytes;
        let unitIndex = 0;
        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }
        return `${size.toFixed(1)} ${units[unitIndex]}`;
    },
    // 清理旧数据（基于时间戳）
    async cleanupOldData(olderThanDays = 30) {
        const cutoffTime = Date.now() - (olderThanDays * 24 * 60 * 60 * 1000);
        let cleanedCount = 0;
        try {
            // 清理旧的会话
            const { dal } = await import('./dal');
            const sessions = await dal.getAllSessions();
            const oldSessions = sessions.filter(session => session.lastPlayedAt < cutoffTime && !session.isActive);
            for (const session of oldSessions) {
                await dal.deleteSession(session.id);
                cleanedCount++;
            }
            console.log(`Cleaned up ${cleanedCount} old sessions`);
            return cleanedCount;
        }
        catch (error) {
            console.error('Failed to cleanup old data:', error);
            return 0;
        }
    },
    // 验证JSON数据
    isValidJSON(str) {
        try {
            JSON.parse(str);
            return true;
        }
        catch {
            return false;
        }
    },
    // 压缩JSON数据（移除空白字符）
    compressJSON(obj) {
        return JSON.stringify(obj);
    },
    // 美化JSON数据（添加缩进）
    prettifyJSON(obj) {
        return JSON.stringify(obj, null, 2);
    },
    // 计算对象大小（近似值）
    calculateObjectSize(obj) {
        return new Blob([JSON.stringify(obj)]).size;
    },
};
// 存储事件监听器
class StorageEventEmitter {
    listeners = new Map();
    on(eventType, listener) {
        if (!this.listeners.has(eventType)) {
            this.listeners.set(eventType, []);
        }
        this.listeners.get(eventType).push(listener);
    }
    off(eventType, listener) {
        const listeners = this.listeners.get(eventType);
        if (listeners) {
            const index = listeners.indexOf(listener);
            if (index > -1) {
                listeners.splice(index, 1);
            }
        }
    }
    emit(event) {
        const listeners = this.listeners.get(event.type);
        if (listeners) {
            listeners.forEach(listener => {
                try {
                    listener(event);
                }
                catch (error) {
                    console.error('Storage event listener error:', error);
                }
            });
        }
    }
}
export const storageEvents = new StorageEventEmitter();
